import React from "react";
import "./App.css";
import HomePage from "./components/Home";
import "./Animate.css";
import "./Nav.css";
import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <HomePage />
    </>
  );
}
export default App;
